import store from '../store/store'
import axios from '../axios'

export default class UserService {

  getLazyUsers(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/usersfilterbypage/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getHelpVideos() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/helpVideos'

        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateUserWidget(id, obj) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/updateUserWidget/' + id
        
        var response = await axios.put(path, obj)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateUserEmail(id, obj) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/updateUserEmail/' + id
        
        var response = await axios.put(path, obj)
        
        // 
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  saveUserWidget(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/saveUserWidget'
        
        var response = await axios.post(path, obj)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getDashboardWidgets() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/dashboardWidgets'

        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomUserWidgetData(path) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getUserWidgetsByUserId(userId) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/getUserWidgets/' + userId
        
        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getUserWidgetsByHard(userId) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/getUserWidgets/' + userId
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/userWidgets`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getUserWidgets(userId) {
    return new Promise(async (resolve, reject) => {
      if (store.getters[`commons/userWidgets`]) {
        resolve(store.getters[`commons/userWidgets`])
  
      } else {
        try {
          var path = '/v1/getUserWidgets/' + userId
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/userWidgets`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
  getUserWidgetData(userId) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/getUserWidgetData/' + userId
        
        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  copyUserWidgetData(fromUserId, toUserId) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/copyUserWidgets/' + fromUserId + '/' +toUserId
        
        var response = await axios.post(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getActiveRolesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeRoles'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activeRoles`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getActiveRoles() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activeRoles`]) {
        resolve(store.getters[`commons/activeRoles`])
  
      } else {
        try {
          var path = '/v1/activeRoles'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activeRoles`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }
  getRolesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/roles'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/roles`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getRoles() {
    return new Promise(async (resolve, reject) => {
      if (store.getters[`commons/roles`]) {
        resolve(store.getters[`commons/roles`])
  
      } else {
        try {
          var path = '/v1/roles'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/roles`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  getAllActiveUsersByHard() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/activeUsers'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activeusers`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllActiveUsers() {
    return new Promise(async (resolve, reject) => {
      if (store.getters[`commons/activeusers`]) {
        resolve(store.getters[`commons/activeusers`])
  
      } else {
        try {
          var path = '/v1/activeUsers'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activeusers`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
  getAllUsersByHard() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/users'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/users`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllUsers() {
    return new Promise(async (resolve, reject) => {
      if (store.getters[`commons/users`]) {
        resolve(store.getters[`commons/users`])
  
      } else {
        try {
          var path = '/v1/users'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/users`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
 
  //MBP

  updateUserById(user, id) {
    let a = {...user}
    if (user.defRegion && user.defRegion.id) {
      a.defRegion = user.defRegion.id
    }
    if (user.role && user.role.id) {
      a.role = user.role.id
    }

    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/updateUser/' + id
        
        var response = await axios.put(path, a)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  updateUser(user) {
    let a = {...user}
    if (user.defRegion && user.defRegion.id) {
      a.defRegion = user.defRegion.id
    }
    if (user.role && user.role.id) {
      a.role = user.role.id
    }

    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/updateUser/'
        
        var response = await axios.put(path, a)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  updateAUser(user) {
    if (user.id) {
      return new Promise(async function(resolve, reject) {
        try {
          var path = '/v1/updateUser/' + user.id
          
          var response = await axios.put(path, user)
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      })
    } else {
      
    }
  }
  updateNewUser(user) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/updateNewUser/'
        
        var response = await axios.put(path, user)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  completeSignup(user) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/user/completeSignup'
        
        var response = await axios.post(path, user)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updatePassword(payload) {
    return new Promise(async (resolve, reject) => {
      try {
        
        var response = await axios.post('https://identitytoolkit.googleapis.com/v1/accounts:update?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw', payload)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  changeEmail(payload) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await axios.post('https://identitytoolkit.googleapis.com/v1/accounts:update?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw', payload)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  refreshToken(refreshToken) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await axios.post(
          'https://securetoken.googleapis.com/v1/token?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw', 
          {
            grant_type: refresh_token,
            refresh_token: refreshToken
          }
        )
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  async sendResetPasswordEmail(payload) {
    // try {
      
      var response = await axios.post('https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw', payload)
      
      return response.data
    // } catch (err) {
    //   // 
    //   return err.response.data.error.message
    // }
  }

  async register(payload) {
    // try {
      
      var response = await axios.post('https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw', payload)
      
      return response.data
    // } catch (err) {
    //   // 
    //   return err.response.data.error.message
    // }
  }

  async login(user) {
    // try {
      
      var response = await axios.post('https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw', user)
      
      return response.data
    // } catch (err) {
    //   // 
    //   return err.response.data.error.message
    // }
  }

  completeSignupWithToken(body, token) {
    
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/user/completeSignup'
        
        var response = await axios.post(
          path, 
          body,
          {
            headers: {
              Authorization: 'Bearer ' + token
            }
          }
        )
        // // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getUserLoginHistory(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/loginHistoryByUser/' + id
        var response = await axios.get(path)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getUserById(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/user/' + id
        var response = await axios.get(path)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getUser(token) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/user/profile'
        var response = await axios.get(path)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getNotifications() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/user/getNotifications'
        var response = await axios.get(path)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateNotifications(data) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/user/updateNotifications'
        var response = await axios.put(path, data)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

}
